import { render, staticRenderFns } from "./ProductAdd.vue?vue&type=template&id=b9bee0a0&scoped=true&"
import script from "./ProductAdd.vue?vue&type=script&lang=js&"
export * from "./ProductAdd.vue?vue&type=script&lang=js&"
import style0 from "./ProductAdd.vue?vue&type=style&index=0&id=b9bee0a0&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9bee0a0",
  null
  
)

export default component.exports